module.exports = {
      id: "step-400-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#step-400-index-usage",
      toString: function () {
        return this.url;
      }
    }